import React, { useState } from 'react';
import './UserGuide.css';

function UserGuide() {
  const [activeSection, setActiveSection] = useState('getting-started');

  const sections = {
    'getting-started': {
      title: 'Başlangıç',
      icon: '🚀',
      content: (
        <div>
          <h3>Enerji Takip'e Hoş Geldiniz!</h3>
          <p>Enerji tüketiminizi takip etmeye başlamak için aşağıdaki adımları takip edin:</p>
          
          <div className="guide-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h4>Hesap Oluşturun</h4>
              <p>Ana sayfadaki "Giriş Yap" butonuna tıklayarak hesabınızı oluşturun.</p>
            </div>
          </div>
          
          <div className="guide-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h4>Cihazlarınızı Bağlayın</h4>
              <p>Desteklenen cihazlar sayfasından cihazınızı seçin ve kurulum talimatlarını takip edin.</p>
            </div>
          </div>
          
          <div className="guide-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h4>Dashboard'u Keşfedin</h4>
              <p>Ana dashboard'da enerji tüketim verilerinizi görüntülemeye başlayın.</p>
            </div>
          </div>
        </div>
      )
    },
    'dashboard': {
      title: 'Dashboard Kullanımı',
      icon: '📊',
      content: (
        <div>
          <h3>Dashboard Özellikleri</h3>
          <p>Dashboard, enerji tüketiminizi takip etmenin ana merkezidir:</p>
          
          <div className="feature-explanation">
            <h4>📈 Gerçek Zamanlı Veriler</h4>
            <p>Tüm cihazlarınızın anlık tüketim verilerini görüntüleyin.</p>
          </div>
          
          <div className="feature-explanation">
            <h4>💰 Maliyet Hesaplaması</h4>
            <p>Otomatik maliyet hesaplamaları ile faturalarınızı önceden tahmin edin.</p>
          </div>
          
          <div className="feature-explanation">
            <h4>🎯 Hedef Belirleme</h4>
            <p>Aylık ve günlük tüketim hedefleri belirleyin ve takip edin.</p>
          </div>
        </div>
      )
    },
    'analytics': {
      title: 'Analitik Sayfası',
      icon: '📈',
      content: (
        <div>
          <h3>Veri Analizi ve Raporlama</h3>
          <p>Analitik sayfasında detaylı veri analizleri yapabilirsiniz:</p>
          
          <div className="feature-explanation">
            <h4>📅 Zaman Dilimi Seçimi</h4>
            <p>Günlük, aylık veya yıllık veriler arasında geçiş yapın.</p>
          </div>
          
          <div className="feature-explanation">
            <h4>📊 Görsel Grafikler</h4>
            <p>Interaktif grafikler ile tüketim trendlerinizi görselleştirin.</p>
          </div>
          
          <div className="feature-explanation">
            <h4>💡 Akıllı Öneriler</h4>
            <p>AI destekli analizler ile tasarruf önerileri alın.</p>
          </div>
        </div>
      )
    },
    'settings': {
      title: 'Ayarlar',
      icon: '⚙️',
      content: (
        <div>
          <h3>Kişiselleştirme ve Yapılandırma</h3>
          <p>Ayarlar sayfasında uygulamayı ihtiyaçlarınıza göre yapılandırın:</p>
          
          <div className="feature-explanation">
            <h4>👤 Profil Bilgileri</h4>
            <p>Kullanıcı bilgilerinizi güncelleyin ve hesap ayarlarınızı yönetin.</p>
          </div>
          
          <div className="feature-explanation">
            <h4>🔔 Bildirim Ayarları</h4>
            <p>Hangi bildirimleri almak istediğinizi seçin ve özelleştirin.</p>
          </div>
          
          <div className="feature-explanation">
            <h4>💰 Fiyatlandırma</h4>
            <p>Enerji birim fiyatlarınızı güncelleyerek doğru maliyet hesaplamaları yapın.</p>
          </div>
        </div>
      )
    },
    'troubleshooting': {
      title: 'Sorun Giderme',
      icon: '🔧',
      content: (
        <div>
          <h3>Yaygın Sorunlar ve Çözümleri</h3>
          
          <div className="troubleshoot-item">
            <h4>❓ Cihazım bağlanmıyor</h4>
            <ul>
              <li>WiFi bağlantınızı kontrol edin</li>
              <li>Cihazın desteklenen listede olduğundan emin olun</li>
              <li>Kurulum adımlarını tekrar takip edin</li>
            </ul>
          </div>
          
          <div className="troubleshoot-item">
            <h4>❓ Veriler güncellenmiyor</h4>
            <ul>
              <li>İnternet bağlantınızı kontrol edin</li>
              <li>Sayfayı yenileyin</li>
              <li>Tarayıcı önbelleğinizi temizleyin</li>
            </ul>
          </div>
          
          <div className="troubleshoot-item">
            <h4>❓ Hesaplamalar yanlış görünüyor</h4>
            <ul>
              <li>Ayarlar sayfasından fiyat bilgilerinizi kontrol edin</li>
              <li>Enerji birimi ayarlarınızı doğrulayın</li>
              <li>Destek ekibiyle iletişime geçin</li>
            </ul>
          </div>
        </div>
      )
    }
  };

  return (
    <div className="user-guide">
      <div className="guide-header">
        <h1>📖 Kullanım Rehberi</h1>
        <p>Enerji Takip uygulamasını en iyi şekilde kullanmanız için detaylı rehber</p>
      </div>

      <div className="guide-content">
        <div className="guide-sidebar">
          <h3>İçindekiler</h3>
          <nav className="guide-nav">
            {Object.entries(sections).map(([key, section]) => (
              <button
                key={key}
                className={`nav-item ${activeSection === key ? 'active' : ''}`}
                onClick={() => setActiveSection(key)}
              >
                <span className="nav-icon">{section.icon}</span>
                <span className="nav-title">{section.title}</span>
              </button>
            ))}
          </nav>
        </div>

        <div className="guide-main">
          <div className="section-header">
            <span className="section-icon">{sections[activeSection].icon}</span>
            <h2>{sections[activeSection].title}</h2>
          </div>
          <div className="section-content">
            {sections[activeSection].content}
          </div>
        </div>
      </div>

      <div className="guide-footer">
        <div className="help-section">
          <h3>💬 Daha Fazla Yardım</h3>
          <p>Rehberde aradığınızı bulamadınız mı? Bizimle iletişime geçin!</p>
          <div className="help-buttons">
            <a href="/support" className="help-button">
              📧 Destek
            </a>
            <a href="/contact" className="help-button">
              💬 Canlı Chat
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserGuide;
